import { Component } from '@angular/core';

@Component({
  selector: 'app-video-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './video-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class VideoIconComponent {}
